export default __webpack_public_path__ + "static/media/newspaper.11e38d41.png";